import { forwardRef as b, createElement as T } from "react";
import { createRoot as C } from "react-dom/client";
import { jsx as m, jsxs as S } from "react/jsx-runtime";
import { c as g } from "./tw-cn-mXgPecoF.mjs";
import { T as I } from "./text-button-CnKFU0fa.mjs";
import { c as N } from "./variance-DhhqoHkK.mjs";
const k = N(["fixed w-full pointer-events-none"], {
  variants: {
    active: {
      true: "",
      false: ""
    },
    position: {
      bottom: "mx-auto left-1/2 bottom-0",
      top: "mx-auto left-1/2 top-20",
      center: "mx-auto left-1/2 top-1/2"
    }
  },
  compoundVariants: [
    // bottom과 top은 같은 애니메이션 사용
    {
      active: !0,
      position: ["bottom", "top"],
      className: "animate-toastFadeIn"
    },
    {
      active: !1,
      position: ["bottom", "top"],
      className: "animate-toastFadeOut"
    },
    // center는 별도의 opacity 애니메이션 사용
    {
      active: !0,
      position: "center",
      className: "animate-toastCenterFadeIn"
    },
    {
      active: !1,
      position: "center",
      className: "animate-toastCenterFadeOut"
    }
  ]
}), _ = N(
  ["inline-flex max-w-[320px] pc:max-w-[343px]", "bg-fill-neutral-main", "px-20 mb-20", "pointer-events-auto"],
  {
    variants: {
      radius: {
        "rounded-4": "rounded-4",
        "rounded-6": "rounded-6",
        "rounded-8": "rounded-8"
      },
      position: {
        bottom: "-translate-x-1/2",
        top: "-translate-x-1/2",
        center: "-translate-x-1/2 -translate-y-1/2"
      },
      hasTextButton: {
        true: "items-center gap-20 justify-between w-[calc(100%-32px)] max-w-none pc:w-[343px]",
        false: ""
      }
    },
    defaultVariants: {
      hasTextButton: !1
    }
  }
), $ = N([
  "text-static-white whitespace-pre-line",
  "typography-body-14-regular break-words line-clamp-2",
  "cursor-default select-none"
]), w = 9999, y = b(
  ({
    active: a,
    children: t,
    radius: e = "rounded-8",
    bottomOffset: r = 0,
    position: n = "bottom",
    textButton: s,
    onAnimationEnd: p = () => {
    },
    // 기본값 9999로 설정
    zIndex: i = w,
    rootContainerClass: u = ""
  }, f) => {
    const c = k({ active: a, position: n }), x = _({ radius: e, position: n, hasTextButton: !!s }), v = $({}), l = typeof r == "number" ? `${r}px` : r;
    return /* @__PURE__ */ m("div", { className: u, children: /* @__PURE__ */ m(
      "div",
      {
        className: c,
        onAnimationEnd: p,
        ref: f,
        style: { paddingBottom: `calc(var(--safe-area-bottom) + ${l})`, zIndex: i },
        children: /* @__PURE__ */ S("div", { className: g([x, e]), children: [
          /* @__PURE__ */ m("div", { className: "py-12", children: /* @__PURE__ */ m("span", { className: v, children: t }) }),
          !!s && /* @__PURE__ */ m(
            I,
            {
              className: "my-8 shrink-0",
              mobileSize: "small",
              onClick: s.onClick,
              pcSize: "small",
              theme: "underline",
              transparent: !0,
              children: s.text
            }
          )
        ] })
      }
    ) });
  }
);
y.displayName = "NDS.Toast";
const A = "toast-container", o = [];
let d;
const R = ({
  id: a,
  className: t = "",
  duration: e = 3e3,
  clearOtherToast: r,
  zIndex: n = w,
  onAnimationEnd: s,
  ...p
}) => {
  const i = a || `toast_${Date.now()}`;
  let u;
  const f = z(i, t, n), c = C(f), x = (h) => {
    clearTimeout(u), c.unmount(), f.remove(), h || s == null || s(), E(l);
  }, v = () => {
    c.render(/* @__PURE__ */ T(y, { ...p, active: !0, key: i })), u = window.setTimeout(() => {
      c.render(/* @__PURE__ */ T(y, { ...p, active: !1, key: i, onAnimationEnd: x }));
    }, e);
  }, l = {
    toastKey: i,
    add: v,
    remove: x
  };
  return r && o.forEach(({ remove: h }) => {
    h();
  }), o.push(l), o.length === 1 && (d = o[0], v()), l;
};
function z(a, t, e) {
  const r = document.querySelector("body"), n = document.createElement("div");
  return n.className = `${A} ${a} ${t}`, n.style.position = "relative", n.style.zIndex = e.toString(), r.appendChild(n);
}
function E(a) {
  const t = o.findIndex((e) => e === a);
  if (o.splice(t, 1), o.length > 0) {
    const e = o[0];
    d = e, e.add();
  }
}
function V(a) {
  for (; o.length; ) {
    const t = o.shift();
    t == null || t.remove(a);
  }
  d == null || d.remove(a);
}
export {
  w as M,
  y as T,
  V as c,
  R as s
};
